import { ThemeProvider } from '@happymoneyinc/styled-components';
import PropTypes from 'prop-types';
import { meta } from '@happymoneyinc/meta';
import { jsx } from 'react/jsx-runtime';

const ThemeWrapper = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/jsx(ThemeProvider, {
    theme: meta,
    children: children
  });
};
ThemeWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
var ThemeWrapper$1 = ThemeWrapper;

export { ThemeWrapper$1 as default };
//# sourceMappingURL=index.js.map
